import { GenIcon, IconBaseProps, IconType } from "react-icons";

export const LinkedInIcon: IconType = (props: IconBaseProps) =>
  GenIcon({
    tag: "svg",
    attr: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
    },
    child: [
      {
        tag: "path",
        attr: {
          d: "M5.93359 17.293H6.18359V17.043V7.49609V7.24609H5.93359H2.96484H2.71484V7.49609V17.043V17.293H2.96484H5.93359ZM13.8281 17.043V17.293H14.0781H17.043V17.043H17.293V11.8047C17.293 10.514 17.1565 9.31405 16.6016 8.43404C16.0301 7.5276 15.0479 7.00781 13.4844 7.00781C12.3248 7.00781 11.4418 7.48964 10.8906 8.08163V7.49609V7.24609H10.6406H7.79688H7.54688V7.49609V17.043V17.293H7.79688H10.7578H11.0078V17.043V12.3242C11.0078 11.7056 11.0684 11.1485 11.287 10.7508C11.393 10.5578 11.5352 10.4047 11.7278 10.2977C11.9219 10.19 12.182 10.1211 12.5352 10.1211C12.8761 10.1211 13.1101 10.2003 13.2758 10.3161C13.442 10.4322 13.5609 10.6001 13.6454 10.814C13.82 11.2562 13.8281 11.8385 13.8281 12.4023V17.043ZM1.47656 0.25H18.5195C19.2044 0.25 19.75 0.789086 19.75 1.44141V18.5586C19.75 19.2074 19.204 19.75 18.5195 19.75H1.47656C0.793415 19.75 0.25 19.2087 0.25 18.5547V1.44141C0.25 0.788237 0.792525 0.25 1.47656 0.25ZM2.47656 4.47656C2.47656 5.56422 3.35839 6.44531 4.44922 6.44531C5.53688 6.44531 6.41797 5.55958 6.41797 4.47656C6.41797 3.38927 5.53651 2.50781 4.44922 2.50781C3.35839 2.50781 2.47656 3.3889 2.47656 4.47656Z",
          fill: "currentColor",
          stroke: "none",
        },
        child: [],
      },
    ],
  })(props);

export default LinkedInIcon;
